import { HubManagementDialog } from "client/Features/Hub/Management/HubManagementDialog/HubManagementDialog";
import { ReactElement } from "react";

export type CommunityMembershipRequestActivityInvocationProps = {
	onDismiss: () => void;
};

export const CommunityMembershipRequestActivityInvocation = (
	props: CommunityMembershipRequestActivityInvocationProps
): ReactElement => {
	const {
		onDismiss
	} = props;

	return (
		<HubManagementDialog
			initialView="communities.membershipRequests"
			onClose={onDismiss}
		/>
	);
};

CommunityMembershipRequestActivityInvocation.displayName = "CommunityMembershipRequestActivityInvocation";
